import Service from '@ember/service';
export const STORAGE_CONSTANTS = Object.freeze({
  PREFIX: 'EMBER_MULTIPASS_COMPONENTS',
  LOGIN_COUNT: 'LOGIN_COUNT',
  LAST_2FA_PROMO_PROMPT_DATE: 'LAST_2FA_PROMO_PROMPT_DATE',
  TWO_FACTOR_PROMO_PROMPT_COUNT: 'TWO_FACTOR_PROMO_PROMPT_COUNT',
  VIEW_PASSKEY_PROMO: 'VIEW_PASSKEY_PROMO'
});
export default class StorageService extends Service {
  constructor() {
    super(...arguments);
  }
  _getStorageKey(key) {
    return `${STORAGE_CONSTANTS.PREFIX}.${key}`;
  }
  _hasStorageItem(key) {
    return localStorage.getItem(this._getStorageKey(key)) !== null;
  }
  _getStorageItem(key) {
    if (this._hasStorageItem(key)) {
      return JSON.parse(localStorage.getItem(this._getStorageKey(key)));
    }
    return undefined;
  }
  _setStorageItem(key, val) {
    localStorage.setItem(this._getStorageKey(key), JSON.stringify(val));
  }
  _removeStorageItem(key) {
    localStorage.removeItem(this._getStorageKey(key));
  }
  getLoginCount() {
    if (!this._hasStorageItem(STORAGE_CONSTANTS.LOGIN_COUNT)) {
      return undefined;
    }
    const {
      count
    } = this._getStorageItem(STORAGE_CONSTANTS.LOGIN_COUNT);
    return count;
  }
  setLoginCount(count) {
    this._setStorageItem(STORAGE_CONSTANTS.LOGIN_COUNT, {
      count
    });
  }
  getLastTwoFactorPromoPromptDate() {
    if (!this._hasStorageItem(STORAGE_CONSTANTS.LAST_2FA_PROMO_PROMPT_DATE)) {
      return undefined;
    }
    const {
      date
    } = this._getStorageItem(STORAGE_CONSTANTS.LAST_2FA_PROMO_PROMPT_DATE);
    return date;
  }
  setLastTwoFactorPromoPromptDate(date) {
    this._setStorageItem(STORAGE_CONSTANTS.LAST_2FA_PROMO_PROMPT_DATE, {
      date
    });
  }
  getTwoFactorPromoPromptCount() {
    if (!this._hasStorageItem(STORAGE_CONSTANTS.TWO_FACTOR_PROMO_PROMPT_COUNT)) {
      return undefined;
    }
    const {
      count
    } = this._getStorageItem(STORAGE_CONSTANTS.TWO_FACTOR_PROMO_PROMPT_COUNT);
    return count;
  }
  setTwoFactorPromoPromptCount(count) {
    this._setStorageItem(STORAGE_CONSTANTS.TWO_FACTOR_PROMO_PROMPT_COUNT, {
      count
    });
  }
  getPasskeyPromoViewDontRemindDate() {
    if (!this._hasStorageItem(STORAGE_CONSTANTS.VIEW_PASSKEY_PROMO)) {
      return;
    }
    const {
      date
    } = this._getStorageItem(STORAGE_CONSTANTS.VIEW_PASSKEY_PROMO);
    return date;
  }
  setPasskeyPromoViewDontRemindDate(date) {
    this._setStorageItem(STORAGE_CONSTANTS.VIEW_PASSKEY_PROMO, {
      date
    });
  }
  removePasskeyPromoViewDontRemindDate() {
    this._removeStorageItem(STORAGE_CONSTANTS.VIEW_PASSKEY_PROMO);
  }
}